import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DesyAngularModule } from 'desy-angular';
import { RouterModule } from '@angular/router';
import { TablesComponent } from '../tables/tables.component';
import { SortingPipe } from '../../pipe/sorting.pipe';
import { SpanishDatePipe } from '@/app/pipe/date.pipe';
import { regulations } from '@/app/interfaces/accession';

@Component({
  selector: 'app-collapsible',
  imports: [DesyAngularModule, CommonModule, RouterModule, TablesComponent, SortingPipe, SpanishDatePipe],
  templateUrl: './collapsible.component.html',
  styleUrls: ['./collapsible.component.scss'],
})
export class CollapsibleComponent {
  @Input() title = '';
  @Input() items = [];
  @Input() description = '';
  @Input() url = '';
  @Input() open = false;
  @Input() itemsTableHeader: string[] = [];
  @Input() itemsTableRows = [];
  @Input() type = '';
  @Input() regulation: regulations = {
    type: '',
    range: '',
    date: '',
    regulationsTitle: '',
    regulationsUrl: '',
    limitTime: '',
  };

  normalizeUrl(u: string): string {
    if (!u) return '';
    return /^(https?:)?\/\//i.test(u) ? u : `https://${u}`;
  }
}
